const dpSlide = (() => {
  const pageDinksPets = (document.getElementById("pageDinksPets") != null);
  if (pageDinksPets) {


    let sW = window.innerWidth;

    let slidesPerView;
    let spaceBetween;

    if (sW > 750) {
      slidesPerView = 1.3
      // spaceBetween = 40
    } else {
      slidesPerView = 1.3
      // spaceBetween = 20
    }

    const swiper = new Swiper("#jsSwiper", {
      loop: true,
      centeredSlides: true,
      slidesPerView: slidesPerView,
      speed: 800,
      navigation: {
        nextEl: ".swiper-btn-next",
        prevEl: ".swiper-btn-prev"
      }
    });

    // let swiperWrap = document.getElementById("jsSwiperWrap")
    // let bgs = swiperWrap.querySelectorAll('.js-bg');
    // let num = swiperWrap.querySelector('.js-num');
    // let ttl = swiperWrap.querySelector('.js-ttl');
    // let listBoxs = swiperWrap.querySelectorAll('.js-list-box');
    // swiper.on('slideChange', function () {
    //   for (let i = 0; i < listBoxs.length; i++) {
    //     bgs[i].classList.remove('act')
    //     listBoxs[i].classList.remove('act')
    //   }
    //   if (swiper.realIndex == 0) {
    //     bgs[0].classList.add('act')
    //     num.textContent = `01`;
    //     ttl.textContent = `#家の犬が一番かわいい（親バカ）`;
    //     listBoxs[0].classList.add('act')
    //   } else if (swiper.realIndex == 1) {
    //     bgs[1].classList.add('act')
    //     num.textContent = `02`;
    //     ttl.textContent = `#最近見つけたお気に入りの鏡`;
    //     listBoxs[1].classList.add('act')
    //   } else if (swiper.realIndex == 2) {
    //     bgs[2].classList.add('act')
    //     num.textContent = `03`;
    //     ttl.textContent = `#近所のおいしいパンで朝食`;
    //     listBoxs[2].classList.add('act')
    //   } else if (swiper.realIndex == 3) {
    //     bgs[3].classList.add('act')
    //     num.textContent = `04`;
    //     ttl.textContent = `#夫がギター片手に子守唄うたってる♪`;
    //     listBoxs[3].classList.add('act')
    //   } else if (swiper.realIndex == 4) {
    //     bgs[4].classList.add('act')
    //     num.textContent = `05`;
    //     ttl.textContent = `#キャンプカフェ！`;
    //     listBoxs[4].classList.add('act')
    //   } else if (swiper.realIndex == 5) {
    //     bgs[5].classList.add('act')
    //     num.textContent = `06`;
    //     ttl.textContent = `#動物の絵本に夢中`;
    //     listBoxs[5].classList.add('act')
    //   } else if (swiper.realIndex == 6) {
    //     bgs[6].classList.add('act')
    //     num.textContent = `07`;
    //     ttl.textContent = `#近くの公園に散歩`;
    //     listBoxs[6].classList.add('act')
    //   }
    // });

    // for (let i = 0; i < listBoxs.length; i++) {
    //   listBoxs[i].addEventListener('click', () => {
    //     if (i == 0) {
    //       swiper.slideToLoop(0)
    //     }
    //     if (i == 1) {
    //       swiper.slideToLoop(1)
    //     }
    //     if (i == 2) {
    //       swiper.slideToLoop(2)
    //     }
    //     if (i == 3) {
    //       swiper.slideToLoop(3)
    //     }
    //     if (i == 4) {
    //       swiper.slideToLoop(4)
    //     }
    //     if (i == 5) {
    //       swiper.slideToLoop(5)
    //     }
    //     if (i == 6) {
    //       swiper.slideToLoop(6)
    //     }
    //   });
    // }




  }
})();
export default dpSlide;